module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-sub-03@t.60b2a56.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-03@t.png
// module id = 0Ja6
// module chunks = 0